import React from "react";
import { MdEdit, MdDelete } from "react-icons/md";

const AnneUniversitaireTable = ({ anneesUniversitaires, loading, onEdit, onDelete }) => {
  const getStatusBadge = (status) => {
    const statusClasses = {
      "En cours": "bg-green-100 text-green-800 border-green-200",
      "Terminé": "bg-gray-100 text-gray-800 border-gray-200",
      "À venir": "bg-blue-100 text-blue-800 border-blue-200",
      // Ajouter d'autres statuts au besoin
    };

    const defaultClass = "bg-gray-100 text-gray-800 border-gray-200";
    const badgeClass = statusClasses[status] || defaultClass;

    return (
      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${badgeClass}`}>
        {status}
      </span>
    );
  };

  return (
    <div className="overflow-hidden rounded-lg shadow-sm border border-gray-200">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th
              scope="col"
              className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-700"
            >
              Année Universitaire
            </th>
            <th
              scope="col"
              className="px-3 py-3.5 text-left text-sm font-semibold text-gray-700"
            >
              Statut
            </th>
            <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
              <span className="sr-only">Actions</span>
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100 bg-white">
          {loading && anneesUniversitaires.length === 0 ? (
            <tr>
              <td
                colSpan="3"
                className="px-3 py-6 text-center text-sm text-gray-500"
              >
                <div className="flex justify-center">
                  <svg className="animate-spin h-5 w-5 text-[#57A863]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                </div>
              </td>
            </tr>
          ) : anneesUniversitaires.length === 0 ? (
            <tr>
              <td
                colSpan="3"
                className="px-3 py-6 text-center text-sm text-gray-500"
              >
                <p>Aucune année universitaire trouvée</p>
                <p className="text-xs text-gray-400 mt-1">Créez une nouvelle année universitaire en cliquant sur le bouton "Nouvelle Année Universitaire"</p>
              </td>
            </tr>
          ) : (
            anneesUniversitaires.map((anneUniv, index) => (
              <tr key={anneUniv.id_anneuniv || index} className="hover:bg-gray-50 transition-colors">
                <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900">
                  {anneUniv.dateuniv}
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-sm">
                  {getStatusBadge(anneUniv.statusuniv)}
                </td>
                <td className="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                  <div className="flex justify-end gap-2">
                    <button
                      onClick={() => onEdit(anneUniv)}
                      className="p-1.5 text-[#57A863] hover:text-[#4c9657] rounded-md hover:bg-gray-100 transition-colors"
                      title="Modifier"
                    >
                      <MdEdit className="h-5 w-5" />
                    </button>
                    <button
                      onClick={() => onDelete(anneUniv)}
                      className="p-1.5 text-red-500 hover:text-red-700 rounded-md hover:bg-gray-100 transition-colors"
                      title="Supprimer"
                    >
                      <MdDelete className="h-5 w-5" />
                    </button>
                  </div>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default AnneUniversitaireTable;